import { HtmlParser } from '@calendly/html-parser'
import { I18n } from '@calendly/i18n'
import { FlexLayout } from '@calendly/ui/components/flex-layout'
import { Link } from '@calendly/ui/components/link'
import { TitleText } from '@calendly/ui/components/typography'
import { Link as RouterLink } from 'react-router-dom'

import { Divider } from 'features/organization_settings/data_deletion/styles'

const DeletionLink = ({ children }) => {
  const profilePath = '/app/personal/profile'

  return (
    <Link as={RouterLink} to={profilePath}>{children}</Link>
  )
}

export const AccountSection = () => (
  <>
    <Divider />
    <FlexLayout direction="column" gap={24}>
      <TitleText level={3} size="x-small">
        {I18n.t('publisher.organization_settings.data_deletion.section.account.title')}
      </TitleText>
      <FlexLayout direction="column" gap={16}>
        <div data-testid="sub-description">
          {
        HtmlParser(
          I18n.t('publisher.organization_settings.data_deletion.section.account.description'),
          { DeletionLink }
        )
      }
        </div>
      </FlexLayout>
    </FlexLayout>
  </>
)
